import { combineReducers } from 'redux';
import search from './search';
import settings from './settings';
import rates from './rates';
import offers from './offers';
import futureOffers from './futureOffers';
import widgetPool from './widgetPool';
import translations from './translations';
import hotels from './hotels';
import hotelprofile from './hotelprofile';
import destinations from './destinations';
import url from './url';
import trustYou from './trustYou';

export default combineReducers({
    search,
    settings,
    rates,
    offers,
    futureOffers,
    widgetPool,
    translations,
    hotels,
    hotelprofile,
    destinations,
    url,
    trustYou,
});
